module.exports = __webpack_public_path__ + "assets/img/00068.374f20df.png";